import { isEqual, uniqBy, kebabCase } from 'lodash';

import { ensureArray } from 'utils/arrays';

export default (
  state = {
    // student/counselor
    busy: false,

    // supervisor & caseload common
    search: '',
    employerSearchTerm: '',
    supervisorSearchTerm: '',

    sessions: {},
    summary: undefined,
    statusCounts: undefined,
    settings: undefined,
    employers: [],
    supervisors: [],
    careerHoursGoal: undefined,
    volunteerHoursGoal: undefined,
    hoursTracked: undefined,
    supervisorSession: undefined,
    supervisorExperienceTypes: undefined,
  },
  { type, ...rest },
) => {
  const { data, restFilters, selected } = rest;
  switch (type) {
    case 'EXPERIENCE_TRACKING/TOGGLE_BUSY':
      return {
        ...state,
        busy: rest.busy,
      };

    case 'EXPERIENCE_TRACKING/POPULATE_STUDENT_EXPERIENCES':
      return {
        ...state,
        sessions: rest.sessions,
      };

    case 'VOLUNTEER_HOURS/TOGGLE_SUPERVISOR_BUSY':
      return {
        ...state,
        supervisorBusy: !state.supervisorBusy,
      };

    case 'VOLUNTEER_HOURS/POPULATE_SUPERVISOR_VH_DETAILS':
      return {
        ...state,
        ...rest,
      };

    case 'VOLUNTEER_HOURS/SET_SEARCH':
      return {
        ...state,
        search: rest.search,
      };

    case 'EXPERIENCE_TRACKING/POPULATE_SETTINGS':
      return {
        ...state,
        settings: rest.settings,
      };

    case 'SET_SUBMIT_ERROR':
      return {
        ...state,
        submitErrorMessage: rest.message,
      };

    case 'EXPERIENCE_TRACKING/POPULATE_SESSIONS_LIST':
      // Replace results when filters are applied or if viewing as supervisor and using pagination buttons
      // shouldGoBackToFirstPage should be used when you don't want to append new items to the end of the table
      if (
        !isEqual(selected, state.sessions.selected) ||
        state.sessions.restFilters?.search !== restFilters?.search ||
        state.sessions.restFilters?.status !== restFilters?.status ||
        state.sessions.restFilters?.ordering !== restFilters?.ordering ||
        restFilters.viewingAsSupervisor ||
        restFilters.shouldGoBackToFirstPage
      ) {
        return {
          ...state,
          sessions: {
            ...data,
            restFilters,
            selected,
          },
        };
      }
      // Append results for infinite scroll
      return {
        ...state,
        sessions: {
          ...data,
          restFilters,
          selected,
          results: uniqBy(
            [...ensureArray(state.sessions.results), ...data.results],
            'id',
          ),
        },
      };

    case 'EXPERIENCE_TRACKING/POPULATE_SESSION_STATUS_COUNTS':
      return {
        ...state,
        statusCounts: Object.entries(rest.data).reduce(
          (obj, [label, duration]) => ({
            ...obj,
            [kebabCase(label)]: duration,
          }),
          {},
        ),
      };
    case 'EXPERIENCE_TRACKING/POPULATE_EMPLOYERS':
      return {
        ...state,
        employers: rest.employers,
        employerSearchTerm: rest.searchTerm,
      };
    case 'EXPERIENCE_TRACKING/POPULATE_SUPERVISORS':
      return {
        ...state,
        supervisors: rest.supervisors,
        supervisorSearchTerm: rest.searchTerm,
      };
    case 'EXPERIENCE_TRACKING/POPULATE_VOLUNTEER_HOUR_GOAL':
      return {
        ...state,
        volunteerHoursGoal: rest.data.configuration.minCount,
      };
    case 'EXPERIENCE_TRACKING/POPULATE_CAREER_HOUR_GOAL':
      return {
        ...state,
        careerHoursGoal: rest.data.configuration.minCount,
      };
    case 'EXPERIENCE_TRACKING/POPULATE_SESSION_SUMMARY':
      return {
        ...state,
        summary: rest.summary,
      };
    case 'EXPERIENCE_TRACKING/POPULATE_HOURS_TRACKED':
      return {
        ...state,
        hoursTracked: rest.hoursTracked,
      };
    case 'EXPERIENCE_TRACKING/POPULATE_SUPERVISOR_SESSION':
      return {
        ...state,
        supervisorSession: rest.session,
      };
    case 'EXPERIENCE_TRACKING/POPULATE_EXPERIENCE_TYPES':
      return {
        ...state,
        supervisorExperienceTypes: rest.data,
      };

    default:
      return state;
  }
};
